/** 足行天下 API 工具 - 作者: zbq, 日期: 2026-05-29 */

import { zqRequest, clearZqSession } from '@/sheep/request/zq';
import {
  getShareFid,
  getInviteShopFilterId,
  persistShopSessionToCookie,
  restoreShopSessionFromCookie,
} from './share';

export function ok(data, msg = 'success') {
  return { code: 0, msg, data };
}

export function fail(msg, data = null) {
  return { code: -1, msg: msg || '操作失败', data };
}

export function getUserId() {
  restoreShopSessionFromCookie();
  return uni.getStorageSync('id') || '';
}

export function getDailishangId() {
  const daili = uni.getStorageSync('dailishangID');
  if (daili) return daili;
  return getUserId();
}

export function getShareId() {
  return getShareFid() || uni.getStorageSync('wxfid') || '';
}

/**
 * 首页方案归属商家过滤 id。
 * 优先级：店级邀请码（扫码进店）> 登录所属店 > 商家本人 > 旧版 wxfid。
 * 邀请码必须压过 member-tenant：苹果微信 cookie 常残留空店 tenant，会把有方案的推广店盖成空白。
 */
export function getHomeMerchantFilterId() {
  restoreShopSessionFromCookie();

  const inviteShop = getInviteShopFilterId();
  if (inviteShop) {
    return inviteShop;
  }

  const uid = getUserId();
  const memberTenant = Number(uni.getStorageSync('member-tenant-id') || 0);
  if (uid && memberTenant > 1) {
    return `t${memberTenant}_agent001`;
  }

  const role = String(uni.getStorageSync('zq_role') || '');
  const isMerchantFlag = uni.getStorageSync('zq_is_merchant');
  const isMerchant =
    !!uid &&
    (isMerchantFlag === true ||
      isMerchantFlag === 'true' ||
      isMerchantFlag === 1 ||
      isMerchantFlag === '1' ||
      role === 'merchant');
  if (isMerchant) {
    if (/^t\d+_agent001$/.test(String(uid))) {
      return uid;
    }
    return uid || '';
  }
  const promoter = getShareId();
  if (promoter) return promoter;
  return '';
}

export { getShareInvite, appendPromoFields, getInviteShopFilterId } from './share';

export function setZqSession(data = {}) {
  if (data.id != null && data.id !== '') {
    uni.setStorageSync('id', data.id);
    uni.setStorageSync('zq_token', String(data.id));
  }
  if (data.phone) uni.setStorageSync('phone', data.phone);
  if (data.fid != null) uni.setStorageSync('fid', data.fid);
  if (data.dailishangID != null) uni.setStorageSync('dailishangID', data.dailishangID);
  if (data.promoterId) {
    uni.setStorageSync('wxfid', String(data.promoterId));
  }
  const openid = data.openid || data.openId;
  if (openid) {
    uni.setStorageSync('openid', openid);
    uni.setStorageSync('openId', openid);
  }
  // 缓存商家标记供首页过滤
  if (data.isMerchant === true || data.merchant === true || data.isMerchant === 1) {
    uni.setStorageSync('zq_is_merchant', true);
    uni.setStorageSync('zq_role', 'merchant');
  } else if (data.id) {
    // 由 mapMember 再写；此处仅在明确非商家时清除
    if (data.isMerchant === false || data.merchant === false) {
      uni.setStorageSync('zq_is_merchant', false);
      uni.setStorageSync('zq_role', 'user');
    }
  }
  const memberTenant = data.tenantId ?? data.tenant_id;
  if (memberTenant != null && memberTenant !== '' && Number(memberTenant) > 0) {
    // 只记会员所属店，绝不覆盖浏览用 tenant-id
    uni.setStorageSync('member-tenant-id', String(memberTenant));
  }
  syncTenantFromMember(data);
  persistShopSessionToCookie();
}

/**
 * 浏览用 tenant-id 与会员所属店解耦。
 * 「成为商家=开新店」后会员常挂在空店；若登录时用 member.tenantId 覆盖，
 * 首页方案会立刻变空。内容店由默认/URL tenantId / 商家邀请码 T| 决定；
 * 余额、团队等按会员 id 跨租户查询，不依赖此头。
 */
export function syncTenantFromMember(_data = {}) {
  // no-op：刻意不覆盖浏览 tenant-id
}

export function syncLoginState() {
  return !!getUserId();
}

export function logoutLocal() {
  clearZqSession();
}

export async function zqCall(url, data = {}, options = {}) {
  try {
    const res = await zqRequest({ url, data, ...options });
    return ok(res.data, res.msg);
  } catch (err) {
    return err?.code !== undefined ? err : fail(err?.msg || '请求失败');
  }
}

export function pickList(body) {
  if (!body) return [];
  if (Array.isArray(body.dataList)) return body.dataList;
  if (Array.isArray(body.list)) return body.list;
  if (body.data?.list) return body.data.list;
  if (Array.isArray(body.data)) return body.data;
  return [];
}

export function footballStatusByTab(tab) {
  const map = { 赛程: 'upcoming', 即时: 'live', 赛果: 'past' };
  return map[tab] || 'upcoming';
}

export function footballTimeRange(tab) {
  const now = Date.now();
  const sec = Math.floor(now / 1000);
  if (tab === '赛果') {
    return { startTimeFrom: sec - 86400 * 30, startTimeTo: sec };
  }
  if (tab === '即时') {
    return { startTimeFrom: sec - 86400, startTimeTo: sec + 86400 };
  }
  return { startTimeFrom: sec, startTimeTo: sec + 86400 };
}

export function mapSort(sort) {
  if (sort === 'time_asc') return '1';
  if (sort === 'time_desc') return '2';
  return '';
}
